import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import About from './about/About';
import Noise from './noise/Noise';
import Clipboard from './clipboard/Clipboard';
import KomachiReader from './komachi/KomachiReader';
import KomachiThread from './komachi/KomachiThread';
import MedicineTracker from './medicine-tracker/MedicineTracker';
import LofiGenerator from './lofi/LofiGenerator';
import NotFound from './NotFound';

const rootElement = document.getElementById('root') as HTMLElement;
const app = ReactDOM.createRoot(rootElement);

app.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="about" element={<About />} />
      <Route path="noise" element={<Noise />} />
      <Route path="clipboard" element={<Clipboard />} />
      <Route path="komachi" element={<KomachiReader />} />
      <Route path="komachi/:id" element={<KomachiThread />} />
      <Route path="medicine-tracker" element={<MedicineTracker />} />
      <Route path="generator" element={<LofiGenerator />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);
